module.exports = __webpack_public_path__ + "img/coverage-4.a3920b7a.svg";